import { Box, SkeletonText, styled, Typography } from '@creditas-ui/react'
import React from 'react'

const ItemValueDetailStyle = styled(Box)`
  margin-bottom: 24px;
`

const ItemValueDetail = ({ loading, title, value, ...props }) => {
  return (
    <ItemValueDetailStyle component="div" {...props}>
      {loading ? (
        <SkeletonText
          color="light"
          lines={2}
          variant="body"
          mr="12px"
          widthLastChildren="80%"
        />
      ) : (
        <>
          <Typography
            mb="8px"
            component="p"
            variant="bodySmRegular"
            color="neutral.60"
          >
            {title}
          </Typography>
          <Typography
            color="neutral.90"
            component="span"
            variant="bodyMdMedium"
          >
            {value}
          </Typography>
        </>
      )}
    </ItemValueDetailStyle>
  )
}

export { ItemValueDetail }
